export const apiUrlDev = "https://us-central1-addy-ai-dev.cloudfunctions.net/admin";

// REACT_APP_LOCAL_ADMIN_API_URL lets a second local backend (another port) serve the dashboard.
export const apiUrlLocal = process.env.REACT_APP_LOCAL_ADMIN_API_URL || "http://localhost:8080/admin";
export const cloudRunApiUrl = "https://backend-prod-zquodzeuva-uc.a.run.app/admin";
export const cloudRunApiUrlDev = "https://backend-dev-u5fn3il7zq-uc.a.run.app/admin";

// Main API URL (for routes like /processing-checklist-templates that are on the 'api' function, not 'admin')
export const mainApiUrl = "https://us-central1-hey-addy-chatgpt.cloudfunctions.net/api";
export const mainApiUrlDev = "https://us-central1-addy-ai-dev.cloudfunctions.net/api";

export const fmsUrl = "https://api.fms.ratemynft.app";

export const apiUrlDevFirebase = "http://127.0.0.1:5003/addy-ai-dev/us-central1/admin";

export const apiUrl = window.location.hostname.includes("localhost") ? apiUrlDevFirebase : "https://us-central1-hey-addy-chatgpt.cloudfunctions.net/admin";

export const apiUrlProdFirebase = "https://us-central1-hey-addy-chatgpt.cloudfunctions.net/admin";

// Voice agent test console (temporary, dev only). Served separately; this page frames it.
export const voiceConsoleUrl = "https://35-239-73-15.sslip.io";
